<template>
    <div class="position-relative" style="z-index: 1;">
        <template v-if="events.length<=0">
            <draggable
                ghost-class="ghost"
                group="appointments"
                :list="events"
            ></draggable>
        </template>
        <template v-else>
            <component
                ghost-class="ghost"
                :is="drag"
                group="appointments"
                :list="events"
            >
                <div v-for="(event, index) in limitedEvents" :key="index" class="monthly-calendar-eventItem" :class="{singleMember:singleMember}">
                    <div
                        :id="id(event)"
                        :class="!event.isBlocker ?'card-custom event-monthly monthly-calendar-eventMultiple' : 'card-custom monthly-calendar-event blocker-monthly'"
                    >
                        <div
                            class="row no-gutters"
                        >
                            <div class="col-auto d-flex justify-content-center align-items-center mr-2" v-show="event.colors.length">
                                <div :style="'background-color: ' + event.colors[0] " style="height: 10px; width: 10px; border-radius: 100%;"></div>
                            </div>
                            <div class="col text-left pr-0 d-flex align-items-center overflow-hidden text-nowrap mr-2">
                                <span class="mr-2 mt-0 monthly-calendar-time">{{ getEventTime(event) }}</span>
                                <span v-if="event.isBlocker" class="small block">
                                    {{event.notes}}
                                </span>
                                <span class="small block" v-if="event.customer" style="max-width: 50px;">
                                    {{ event.customer.first_name }}
                                    {{ event.customer.last_name }}
                                </span>
                            </div>
                            <div class="col-auto d-flex justify-content-center align-items-center" v-if="!event.isBlocker">
                                <div class="bg-white monthly-calendar-whiteCircle">
                                    <status-badge :status="event.status" :iconOnly="true" :noBadge="true"></status-badge>
                                </div>
                            </div>
                        </div>
                    </div>
                    <popover :id="id(event)" :event="event"></popover>
                </div>
            </component>
        </template>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

import Popover from '../../Popover.vue'
import duration from '@/filters/duration.js';
import draggable from 'vuedraggable'
import StatusBadge from '@/components/StatusBadge';

export default {
    props: {
        idExtraSuffix: String,
        events: Array,
        clickEvent: Function,
        date: null,
        change: Function,
        move: Function,
        singleMember: Boolean,
        step: Number,
        lineHeight: Number,
        lineWidth: Number,
        isLimited: Boolean,
    },
    filters: { duration },

    components: {
        draggable,
        Avatar,
        Popover,
        StatusBadge,
    },
    computed: {
        limitedEvents() {
            let events = this.$deepCopy(this.events);
            if (events.length > 5) {
                if (this.isLimited) {
                    return events.slice(0, 4);
                } else {
                    events.splice(0, 4);
                    return events;
                }
            }
            return events.slice(0, 5);
        },
        drag() {
            let check = this.$checkDevice();
            if (check) {
                return 'div';
            }
            return 'draggable';
        }
    },
    data() {
        return {
            draggable: false,
            dragging: false,
        }
    },
    methods: {

        id(event) {
            return 'popupover-' + event._id + this.idExtraSuffix;
        },

        duration(start, end) {
            let startTime = this.$moment(start);
            let endTime = this.$moment(end);
            return endTime.diff(startTime, 'minutes');
        },

        getEventTime(event) {
            if (event.services[0])
                return this.$moment(event.services[0].startAt).format('HH:SS');
            else
                return this.$moment(event.startAt).format('HH:SS');
        }
    }
}
</script>

<style lang="scss">

.monthly-calendar {
    &-time {
        font-size: 11px;
        opacity: .6;
        font-weight: 300;
        width: 30px;
    }
    &-whiteCircle {
        height: 16px;
        width: 16px;
        background-color: #bbb;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
            font-size: 12px;
        }
    }
    &-eventMultiple {

    }

    &-eventItem {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    &-event .singleMember {
        width: 100% !important;
    }
    &-event {
        position: absolute;
        width: 80%;
        overflow: hidden;
    }
    &-event .badge {
        display: block;
        text-align: left;
        font-size: 12px;
    }

    &-event:hover {
        position: initial!important;
        box-shadow: none!important;
        min-height: initial!important;
    }
}

.blocker-monthly{
    display: block;
    position: relative;
    width: 100%;
    border: 1px solid #EDF2F9;
    border-radius: 5px;
    background: linear-gradient(45deg, #ffffff 22%, #f4f4f4 22%, #f4f4f4 50%, #ffffff 50%, #ffffff 72%, #f4f4f4 72%, #f4f4f4 100%);
    background-size: 25px 25px;
}

.user-1 {
    background-color: #ffefe6;
}
</style>
